var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuessLms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 18,
    viewBox: "0 0 22.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26906",
    "data-name": "Trac\\xE9 26906",
    d: "M25.375,19.25H24.25V11.375A3.378,3.378,0,0,0,20.875,8H9.625A3.378,3.378,0,0,0,6.25,11.375V19.25H5.125A1.128,1.128,0,0,0,4,20.375v2.25A3.378,3.378,0,0,0,7.375,26h15.75A3.378,3.378,0,0,0,26.5,22.625v-2.25A1.128,1.128,0,0,0,25.375,19.25ZM8.5,11.375A1.128,1.128,0,0,1,9.625,10.25h11.25A1.128,1.128,0,0,1,22,11.375V19.25H8.5Zm15.75,11.25a1.128,1.128,0,0,1-1.125,1.125H7.375A1.128,1.128,0,0,1,6.25,22.625V21.5h18Z",
    transform: "translate(-4 -8)",
    fill: "#6f7070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuessLms);
export default __webpack_public_path__ + "static/media/quess_lms.169633b4533d0e74c0c8f40393605072.svg";
export { ForwardRef as ReactComponent };